// extracted by mini-css-extract-plugin
module.exports = {"card":"PartCard_card__3WYg9","imageIcon":"PartCard_imageIcon__2AhcN"};